import { Sanitize } from '../../Sanitize/Sanitize';
import LinkSVG from '../Components/Link.svg';

import { makeText } from '../../../util';
import SimpleAccordion from './SimpleAccordion';
import CookieTable from './CookieTable';

const Tag = ({ vendorName, url, style = {} }) => (
  <a style={style} href={url} target="_blank" className="vendor-tag linked">
    <span>{vendorName}</span>
    <img src={LinkSVG} alt="" />
  </a>
);

export const VendorContent = ({
  vendor,
  settings,
  language,
  dev,
  consentType,
  accordionOpen,
}) => {
  const cookieText = makeText(Boolean(dev), settings, 'cookieText', language);
  const tableCookieText = makeText(Boolean(dev), settings, 'tableCookieText', language);
  const tableCategoryText = makeText(Boolean(dev), settings, 'tableCategoryText', language);
  const tableDomainText = makeText(Boolean(dev), settings, 'tableDomainText', language);
  const tableDurationText = makeText(Boolean(dev), settings, 'tableDurationText', language);

  // IAB Categories
  const iabConsent = makeText(Boolean(dev), settings, 'iabConsent', language);
  const iabLegInt = makeText(Boolean(dev), settings, 'iabLegInt', language);
  const iabFeatures = makeText(Boolean(dev), settings, 'iabFeatures', language);
  const iabSpecialFeatures = makeText(Boolean(dev), settings, 'iabSpecialFeatures', language);
  const iabSpecialPurposes = makeText(Boolean(dev), settings, 'iabSpecialPurposes', language);
  const privacyPolicyTitleText = makeText(Boolean(dev), settings, 'privacyPolicyTitleText', language);
  const legitIntUrlTitleText = makeText(Boolean(dev), settings, 'legitIntUrlTitleText', language);
  const purposeTitleText = makeText(Boolean(dev), settings, 'purposeTitleText', language);
  const purposesTableHeaderText = makeText(Boolean(dev), settings, 'purposesTableHeaderText', language);
  const retentionTableHeaderText = makeText(Boolean(dev), settings, 'retentionTableHeaderText', language);
  const dataCategoriesTitleText = makeText(Boolean(dev), settings, 'dataCategoriesTitleText', language);

  const consentCatsWithRetention = vendor.consentCategories.some(({ retention }) => retention)
  const liCatsWithRetention = vendor.legIntCategories.some(({ retention }) => retention)
  const specialPurposesWithRetention = !!vendor.iabSpecialPurposesObjs

  return (
    <div className="vendor-content">
      {vendor.description && (
        <p className="pm-sub-p" dangerouslySetInnerHTML={{ __html: Sanitize({ html: vendor.description }) }} />
      )}
      {vendor.cookieHeader && (
        <div className="vendor-cookie-header">{vendor.cookieHeader}</div>
      )}
      <div style={{ flexDirection: 'row', alignItems: 'center' }}>
        <div style={{ marginRight: 5 }}>
          {privacyPolicyTitleText}:
        </div>
        <Tag
          style={{ margin: 0 }}
          vendorName={vendor.name}
          url={vendor.policyUrl}
          accordionOpen={accordionOpen}
        />
      </div>
      {vendor.legIntUrl && (
        <div style={{ flexDirection: 'row', alignItems: 'center' }}>
          <div style={{ marginRight: 5 }}>
            {legitIntUrlTitleText}:
          </div>
          <Tag
            style={{ margin: 0 }}
            vendorName={vendor.name}
            url={vendor.legIntUrl}
            accordionOpen={accordionOpen}
          />
        </div>
      )}
      <hr />
      <h2>
        {purposeTitleText}
      </h2>
      <div>
        {(consentType === 'consent' && (consentCatsWithRetention || specialPurposesWithRetention)) && (
          <table
            style={{ border: '1px solid #00000038', padding: 10, borderRadius: 5 }}
          >
            {consentCatsWithRetention && (
              <>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    {purposesTableHeaderText}
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    {retentionTableHeaderText}
                  </th>
                </tr>
                {vendor.consentCategories.map(c => (
                  <tr>
                    <td>
                      {c.name}
                    </td>
                    <td style={{ textAlign: 'center', minWidth: 100 }}>
                      {c.retention || '-'}
                    </td>
                  </tr>
                ))}
              </>
            )}
            {specialPurposesWithRetention && (
              <>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    {iabSpecialPurposes}
                  </th>
                </tr>
                {vendor.iabSpecialPurposesObjs.map(sp => (
                  <tr>
                    <td>
                      {sp.name}
                    </td>
                    <td style={{ textAlign: 'center', minWidth: 100 }}>
                      {sp.retention || '-'}
                    </td>
                  </tr>
                ))}
              </>
            )}
          </table>
        )}
        {(consentType === 'li' && (liCatsWithRetention || specialPurposesWithRetention)) && (
          <table
            style={{ border: '1px solid #00000038', padding: 10, borderRadius: 5 }}
          >
            {liCatsWithRetention && (
              <>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    {iabLegInt}
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    {retentionTableHeaderText}
                  </th>
                </tr>
                {vendor.legIntCategories.map(c => (
                  <tr>
                    <td>
                      {c.name}
                    </td>
                    <td style={{ textAlign: 'center', minWidth: 100 }}>
                      {c.retention || '-'}
                    </td>
                  </tr>
                ))}
              </>
            )}
            {specialPurposesWithRetention && (
              <>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    {iabSpecialPurposes}
                  </th>
                </tr>
                {vendor.iabSpecialPurposesObjs.map(sp => (
                  <tr>
                    <td>
                      {sp.name}
                    </td>
                    <td style={{ textAlign: 'center', minWidth: 100 }}>
                      {sp.retention || '-'}
                    </td>
                  </tr>
                ))}
              </>
            )}
          </table>
        )}
        {(consentType === 'consent' && !consentCatsWithRetention && vendor.consentCategories.length > 0) && (
          <div className="vendor-info">
            <div className="info-title">
              <h3 class="vendor-purposes-header">
                {iabConsent}
              </h3>
            </div>
            {vendor.consentCategories.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {(consentType === 'li' && !liCatsWithRetention && vendor.legIntCategories.length > 0) && (
          <div className="vendor-info">
            <div className="info-title">
              <h3 class="vendor-purposes-header">
                {iabLegInt}
              </h3>
            </div>
            {vendor.legIntCategories.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabFeatures.length > 0 && (
          <div className="vendor-info">
            <div className="info-title">
              <h3 class="vendor-purposes-header">
                {iabFeatures}
              </h3>
            </div>
            {vendor.iabFeatures.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {vendor.iabSpecialFeatures.length > 0 && (
          <div className="vendor-info">
            <div className="info-title">
              <h3 class="vendor-purposes-header">
                {iabSpecialFeatures}
              </h3>
            </div>
            {vendor.iabSpecialFeatures.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
        {(!specialPurposesWithRetention && vendor.iabSpecialPurposes.length > 0) && (
          <div className="vendor-info">
            <div className="info-title">
              <h3 class="vendor-purposes-header">
                {iabSpecialPurposes}
              </h3>
            </div>
            {vendor.iabSpecialPurposes.map(c => <div>&#8226; {c.name || c}</div>)}
          </div>
        )}
      </div>
      {(vendor.iabDataCategories && vendor.iabDataCategories.length)
        ? (
          <div>
            <h3>{dataCategoriesTitleText}</h3>
            {vendor.iabDataCategories.map((d, i) => (
              <SimpleAccordion dataCategory={d} first={i === 0} last={i === vendor.iabDataCategories.length - 1} />
            ))}
          </div>
        )
        : null}
      {vendor.cookies.length > 0 && (
        <div className="vendor-cookies">
          <table className="tvtbl">
            <caption className="cookie-title" style={{ textAlign: 'left' }}>
              {cookieText}
            </caption>
            <tr>
              <th>{tableCookieText}</th>
              <th>{tableDomainText}</th>
              <th>{tableCategoryText}</th>
              <th>{tableDurationText}</th>
            </tr>
            {vendor.cookies.length > 0 && (
              <CookieTable cookies={vendor.cookies} />
            )}
          </table>
        </div>
      )}
    </div>
  );
};